import { render } from "./BrandPausenzeitung.vue?vue&type=template&id=3caeeff5"
import script from "./BrandPausenzeitung.vue?vue&type=script&lang=ts"
export * from "./BrandPausenzeitung.vue?vue&type=script&lang=ts"

import "./BrandPausenzeitung.vue?vue&type=style&index=0&id=3caeeff5&lang=scss"
script.render = render

export default script